import { useState, useCallback, useMemo } from 'react';
import { WorklistView } from '../../../../../../services/CaseManagementService';

/**
 * Hook for managing worklist search and filtering
 */
export function useWorklistSearch(worklistItems: WorklistView[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredWorklistItems = useMemo(() => {
    if (!searchTerm.trim()) {
      return worklistItems;
    }

    const searchLower = searchTerm.toLowerCase();
    return worklistItems.filter(
      (item) =>
        item.patient?.toLowerCase().includes(searchLower) ||
        item.account?.toLowerCase().includes(searchLower) ||
        item.physician?.toLowerCase().includes(searchLower) ||
        item.payer?.toLowerCase().includes(searchLower) ||
        item.admitType?.toLowerCase().includes(searchLower) ||
        item.admitSource?.toLowerCase().includes(searchLower)
    );
  }, [worklistItems, searchTerm]);

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  return {
    searchTerm,
    filteredWorklistItems,
    handleSearchChange,
    handleClearSearch,
  };
}
